/**
 * Task statuses in the app's language. Every team starts with four statuses the
 * backend seeds in English (models.py DEFAULT_TASK_STATUSES); until someone renames
 * one, it shows in the reader's language. A renamed or new status shows as written.
 */
const SEEDED = { not_started: 'To Do', in_progress: 'In Progress', completed: 'Completed', archived: 'Archived' };
const VALUE_CATEGORY = { todo: 'not_started', not_started: 'not_started', in_progress: 'in_progress', completed: 'completed', archived: 'archived' };

/** The name of a status object ({ name, category }). */
export const statusName = (status, t) => {
  if (!status) return '';
  return SEEDED[status.category] && SEEDED[status.category] === status.name
    ? t(`task_statuses.default.${status.category}`)
    : status.name || '';
};

/** The name of a plain status value (todo, in_progress, completed, archived). */
export const statusValueName = (value, t) => t(`task_statuses.default.${VALUE_CATEGORY[value] || 'not_started'}`);
